// extracted by mini-css-extract-plugin
export default {"customButton":"buttons_customButton__NfVhN","iconWrapper":"buttons_iconWrapper__R0ukv"};